import React from "react";
import PropTypes from "prop-types";
import styles from "./CircleBadge.module.css";

export function CircleBadge({
  label,
  title,
  bgColor = "#ffffff",
  textColor = "#000000",
  borderColor = "#000000",
  size = "medium",
  highlighted = false,
}) {
  return (
    <span
      className={`${styles.wrap} ${styles[`wrap_${size}`] || ""} ${
        highlighted ? styles.highlighted : ""
      }`}
    >
      <span
        className={`${styles.badge} ${styles[size] || styles.medium}`}
        title={title || label}
        style={{
          background: bgColor,
          color: textColor,
          borderColor: borderColor,
        }}
      >
        {label}
      </span>
    </span>
  );
}

CircleBadge.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  borderColor: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  highlighted: PropTypes.bool,
};

export default CircleBadge;
